const find = (selector, element = document) => [].slice.call(element.querySelectorAll(selector));
const findOne = (selector, element = document) => element.querySelector(selector);

const hideButton = button => {
  button.style.opacity = 0;
  setTimeout(() => {
    button.style.height = '0px';
  }, 700);
};

const adjustMaxHeight = (element, delay, delay2) => {
  setTimeout(() => {
    element.style.maxHeight = `${element.scrollHeight + 20}px`;
    if (delay2) {
      setTimeout(() => {
        element.style.maxHeight = `${element.scrollHeight + 20}px`;
      }, delay2);
    }
  }, delay);
};

export default el => {
  const reviews = find('.review', el);
  const wrapper = findOne('.reviews', el);
  const button = findOne('.ratings__moreButton', el);

  if (reviews.length <= 5) {
    button.style.display = 'none';
  } else {
    reviews.slice(5).forEach((review) => {
      review.classList.add('review--hidden');
    });

    button.addEventListener('click', () => {
      reviews.forEach(review => {
        review.classList.remove('review--hidden');
      });

      hideButton(button);

      adjustMaxHeight(wrapper, 10, 50);
    });

    adjustMaxHeight(wrapper, 100);
  }
}
